<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:00em;">Dr Alex Cicchinelli for his support, encouragement and suggestions.</p><br/>
<p style="text-indent:00em;">Thanks to Christopher Coffey for the photos used in the design of the cover.</p><br/>
<p style="text-indent:00em;">Austin Macauley Publishers for giving a first-time author the opportunity.</p><br/>
<p style="text-indent:00em;">The Welsh people I met along the way who were always ready to share their proud Welshness with me.</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?0711a214